import { render, staticRenderFns } from "./SaveChangesDialog.vue?vue&type=template&id=1a11cd61&scoped=true&"
import script from "./SaveChangesDialog.vue?vue&type=script&lang=js&"
export * from "./SaveChangesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a11cd61",
  null
  
)

export default component.exports